<template>
  <standard-page :module="module">
    <template v-slot:buttons>
      <page-button text="Add Template" type="add" @click="newTemplate('Did')" />
    </template>
    <template v-slot:content>
      <paged-table :busy="busy" :fields="fields" :items="didTemplates" :sort-by="sortBy">
        <template #cell(name)="data">
          <rename-column :is-edit="data.item.isEdit" :value="data.value" @cancel="cancel(data.item)" @save="e => save(e, data.item)" @view="view(data.item)" />
        </template>
        <template #cell(created_at)="data">
          {{ data.value | date }}
        </template>
        <template #cell(actions)="data">
          <action-button title="Rename Catalog" type="rename" @click="edit(data.item)" />
          <action-button title="Delete Template" type="delete" @click="itemToDelete(data.item)" />
          <action-button title="Export Template" type="export" @click="exportTemplateAsExcel(data.item)" />
          <toggle-switch :value="data.item.template==catalogInternal.did_template" @change="check($event, data.item)" />
        </template>
      </paged-table>
      <delete-modal-new :open.sync="confirmationModalOpen" :context="'Template'" @delete="deleteItem()" />
    </template>
  </standard-page>
</template>

<script>
import Vue from 'vue';
import {apiMixin} from '@/utils/api-mixin';
import {defineComponent} from '@vue/composition-api';
import XLSX from 'xlsx';

export default defineComponent({
  name: 'DidTemplates',
  mixins: [apiMixin('identity')],
  props: ['catalogid', 'catalog'],
  data() {
    return {
      fields: [
        {
          key: 'name',
          label: 'Name',
          class: 'main-col',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Created',
        },
        {
          key: 'allow_custom',
        },
        {
          key: 'actions',
          class: 'actions-col',
        },
      ],
      catalogInternal: this.catalog,
      didTemplates: [],
      busy: false,
      templateToDelete: null,
      sortBy: 'name',
      confirmationModalOpen: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      if (!this.catalog) {
        await this.getCatalog();
      }
      await this.getDidTemplates();
    },
    async getCatalog() {
      this.catalogInternal = await this.callApi('busy', false, 'get:Catalog', () => this.$api.get(`/identity/catalogs/${this.catalogid}`));
    },
    async getDidTemplates() {
      this.didTemplates = await this.callApi('busy', false, 'get:DID Templates', () => this.$api.get('/identity/templates?template_type=Did'));
    },
    edit(item) {
      Vue.set(item, 'isEdit', true);
    },
    async save(value, item) {
      Vue.set(item, 'isEdit', false);
      item.name = value.trim();
      //TODO: use vee-validate
      if (item.name.length > 0) {
        await this.callApi('loader', true, 'rename:Template', () => this.$api.patch(`/identity/templates/${item.template}`, {name: item.name}));
      } else {
        this.$toastr.e('Please provide a name first!', 'Failed');
      }
    },
    cancel(item) {
      Vue.set(item, 'isEdit', false);
    },
    async check(checked, item) {
      if (checked) {
        await this.callApi('loader', false, 'update:Templates', () => this.$api.patch(`/identity/catalogs/${this.catalogid}/templates`, {template: item.template}));
      } else {
        await this.callApi('loader', false, 'update:Templates', () => this.$api.patch(`/identity/catalogs/${this.catalogid}/templates`, {template: null}));
      }
    },
    view(item) {
      this.$router.push({name: 'view-and-edit-template', params: {catalogid: this.catalogid, templateid: item.template}});
    },
    newTemplate(templateType) {
      this.$router.push({name: 'new-template', params: {catalogid: this.catalogid, templateType: templateType}});
    },
    itemToDelete(item) {
      this.templateToDelete = item.template;
      this.confirmationModalOpen = true;
    },
    async deleteItem() {
      await this.callApi('busy', true, 'delete:Template', () => this.$api.delete(`identity/templates/${this.templateToDelete}`));
      await this.getDidTemplates();
    },
    async exportTemplateAsExcel(template) {
      try {
        let data = await this.$api.get(`identity/templates/${template.template}/template_properties`);
        data = data.map(d => ({
          name: d.name,
          fact_type: d.fact_type,
          options: d.options,
          required: d.required,
          property_group: d.property_group,
          repeatable: d.repeatable,
          private: d.private
        }))
        let workbook = XLSX.utils.book_new();
        let worksheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');
        XLSX.writeFile(workbook, `${template.name}.xlsx`);
      } catch (e) {
        console.error(e)
        this.$toastr.e('Export failed', 'Failure');
      }
    },
  }
}
);
</script>

<style scoped>
</style>
